import { BTC } from "rujira.js";

export const isPeggedPair = (base: string, quote: string): boolean =>
  (base.includes("USD") && quote.includes("USD")) ||
  (base.includes(BTC) && quote.includes(BTC)) ||
  (base === "bRUNE" && quote === "RUNE");
